<div class="animated fadeIn rounded">
  <div class="card">
    <div class="card-header">
      <i class="fa fa-archive"></i> Productos
      <div class="card-header-actions btn-group">
        <!-- <button class="btn btn-sm btn-outline-success" type="button"><i class="fa fa-regular fa-floppy-disk"></i>&nbsp;Guardar Orden</button> -->
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="showPromotions()"><i
            class="fa fa-percent"></i>&nbsp;Promociones</button>
      </div>
    </div>
    <div class="card-body">
      <pos-table tableFormId="productTableId" [headers]="getProductTableColumns()" [filters]="getProductFilterColumns()"
        [data]="products" [itemsPerPage]="10" (dataChange)="getProductData($event)">
      </pos-table>
    </div>
  </div>
</div>